import { Checkbox } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface ISkillCheckboxProps {
    skill: string;
    isChecked: boolean;
    onChange: (skill: string, isChecked: boolean) => void;
}

export default function SkillCheckbox(props: ISkillCheckboxProps) {
    const { skill, isChecked, onChange } = props;
    const { t } = useTranslation("recruitment");

    const handleChange = (checked: boolean) => onChange(skill, checked);

    return (
        <div>
            <Checkbox
                checked={isChecked}
                onChange={(_, d) => handleChange(!!d.checked)}
                label={t(`register.form.${skill}`)}
                />
        </div>
    );
}